import React from 'react';
import { Box, makeStyles, Typography, CircularProgress, IconButton } from "@material-ui/core";
import { Download, Trash2 } from "react-feather";
import { SECONDARY_COLOR } from '../../theme';
import TooltipPersonalizado from './TooltipPersonalizado';

const CardArquivo = ({ arquivo, handleExcluirArquivo, handleBaixarArquivo, excluirArquivoDesativado }) => {
    const classes = useStyles();

    const iconeBaixarArquivo = (arquivoSelecionado) => (

        arquivoSelecionado.baixando
            ?
            <Box className="pt-2 pr-2 pl-2">
                <CircularProgress size={20} />
            </Box>
            :
            <IconButton
                title="Baixar Arquivo"
                onClick={handleBaixarEvent}
                className="p-2"
            >
                <Download color={SECONDARY_COLOR} size={20} />
            </IconButton>
    );

    const handleClickCard = () => {
        handleBaixarArquivo(arquivo);
    };

    const handleExcluirEvent = (event) => {
        event.stopPropagation();
        handleExcluirArquivo(arquivo);
    };

    const handleBaixarEvent = (event) => {
        event.stopPropagation();
        handleBaixarArquivo(arquivo);
    }

    return (
        <Box display="flex" alignItems="center" className={classes.boxCard + " borda-padrao"} onClick={handleClickCard}>
            <Box className={classes.nomeArquivo}>
                <TooltipPersonalizado title={arquivo.nome}>
                    <Typography className={"mt-4 mb-4 mr-3 ml-3 text-overflow-ellipsis"}>
                        {arquivo.nome}
                    </Typography>
                </TooltipPersonalizado>
            </Box>
            <Box display="flex" justifyContent="flex-end" className={classes.icones + " pr-2"}>

                {arquivo.guid || arquivo.id
                    ? <>

                        {excluirArquivoDesativado
                            ? <>
                                {iconeBaixarArquivo(arquivo)}
                            </>
                            :
                            <>
                                <IconButton
                                    title="Excluir Arquivo"
                                    onClick={handleExcluirEvent}
                                    className="p-2"
                                >
                                    <Trash2 size={18} />
                                </IconButton>

                                {iconeBaixarArquivo(arquivo)}
                            </>

                        }

                    </>
                    : <CircularProgress className="mr-2" size={20} />
                }
            </Box>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    nomeArquivo: {
        width: "calc(100% - 76px)"
    },
    icones: {
        width: "76px"
    },
    boxCard: {
        cursor: "pointer"
    }
}));

export default CardArquivo;